/**
 * 在这些页面中锁定 Topbar 的公司选择器。
 *
 * 原因：
 * - 新建页面进入后，创建目标公司不能中途改变。
 * - 编辑页面加载的是确定的资源，不能通过 Topbar 切换上下文。
 */
const COMPANY_CONTEXT_LOCKED_ROUTES = [
    // Company
    /^\/company\/new\/?$/,
    /^\/company\/edit\/[^/]+\/?$/,

    // Shops
    /^\/shops\/new\/?$/,
    /^\/shops\/edit\/[^/]+\/?$/,

    // Dropoffs
    /^\/dropoff\/new\/?$/,
    /^\/dropoff\/edit\/[^/]+\/?$/,

    // Motorcycles
    /^\/motorcycles\/new\/?$/,
    /^\/motorcycles\/[^/]+\/?$/,

    // Discounts
    /^\/discounts\/new\/?$/,
    /^\/discounts\/edit\/[^/]+\/?$/,

    // Bookings
    /^\/bookings\/new\/?$/,
    /^\/bookings\/edit\/[^/]+\/?$/,

    // Requests
    /^\/requests\/edit\/[^/]+\/?$/,

    // Reviews
    /^\/reviews\/edit\/[^/]+\/?$/,

    // Unverified companies
    /^\/unverified-companies\/edit\/[^/]+\/?$/,

    // Motorcycle models
    /^\/models\/new\/?$/,
    /^\/models\/edit\/[^/]+\/?$/,

    // Promotion codes
    /^\/codes\/promo\/new\/?$/,
    /^\/codes\/promo\/[^/]+\/?$/,

    // Credit codes
    /^\/codes\/credits\/new\/?$/,
    /^\/codes\/credits\/[^/]+\/?$/,
];

/**
 * 返回当前 pathname 是否属于新建或编辑页面。
 */
export const isCompanyContextLockedRoute = (
    pathname = '',
) => {
    return COMPANY_CONTEXT_LOCKED_ROUTES.some(
        (pattern) => pattern.test(pathname),
    );
};